import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { getFileExtension, retrieveFromLocalStorage, toBase64 } from '../../utils/util';

import {
  requestUpdatePersonDetails,
  requestViewPersonDetails,
  requestUpdatePersonUsername,
  requestUpdatePersonEmail,
  requestUpdateProfilePicture,
  requestAddRepresentative,
} from '../../api/party/party.actions';

import MyProfile from '../../components/screens/my-profile/MyProfile';

const MyProfileContainer = () => {
  const dispatch = useDispatch();

  const { details, profile } = useSelector(({ party }) => party);

  const personExternalReference = retrieveFromLocalStorage('personExternalReference');

  useEffect(() => {
    dispatch(requestViewPersonDetails({ personExternalReference }));
  }, [dispatch, personExternalReference]);

  const updateDetails = (details) => {
    dispatch(
      requestUpdatePersonDetails({
        details: {
          ...details,
          personExternalReference,
        },
      })
    );
  };

  const updateUsername = (username, onSuccess) => {
    dispatch(
      requestUpdatePersonUsername({
        input: {
          personExternalReference,
          username,
        },
        onSuccess,
      })
    );
  };

  const updateEmail = (email, onSuccess) => {
    dispatch(
      requestUpdatePersonEmail({
        input: {
          personExternalReference,
          email,
        },
        onSuccess,
      })
    );
  };

  const updateProfilePicture = async (file) => {
    const profilePictureBase64 = await toBase64(file);
    const documentType = getFileExtension(file.name);

    const input = {
      personExternalReference,
      documentType,
      profilePictureBase64,
    };

    dispatch(requestUpdateProfilePicture({ input }));
  };

  const addRepresentative = (email, onSuccess) => {
    dispatch(
      requestAddRepresentative({
        input: {
          companyExternalReference: profile.organisationExternalReference,
          representativeEmail: email,
          personExternalReference,
        },
        onSuccess,
      })
    );
  };

  return (
    <MyProfile
      details={details}
      profile={profile}
      updateDetails={updateDetails}
      updateUsername={updateUsername}
      updateEmail={updateEmail}
      updateProfilePicture={updateProfilePicture}
      addRepresentative={addRepresentative}
    />
  );
};

export default MyProfileContainer;
